import { render } from "./PostActionsPill.vue?vue&type=template&id=461ec08a&scoped=true"
import script from "./PostActionsPill.vue?vue&type=script&lang=js"
export * from "./PostActionsPill.vue?vue&type=script&lang=js"

import "./PostActionsPill.vue?vue&type=style&index=0&id=461ec08a&lang=scss&scoped=true"

import exportComponent from "/build/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-461ec08a"]])

export default __exports__